import React from 'react';
import LinkPush from '../platformui/LinkPush';
export default (props) => <LinkPush {...props} useBackgroundImage={true} />;
